export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-primary-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-200 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                随时随地
              </span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">移动端随时吃瓜</h2>
              <p className="text-background-200/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                关注黑料爆料网公众号，下载专属APP，随时随地接收最新爆料推送。支持iOS和Android双平台，消息推送快人一步。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-semibold text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </button>
              </div>
            </div>
            <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-0">
              <div className="w-56 h-72 md:w-64 md:h-80 rounded-2xl overflow-hidden shadow-xl border-4 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20mobile%20app%20screen%20mockup%20showing%20a%20news%20feed%20interface%20with%20headlines%20and%20thumbnails%2C%20warm%20dark%20crimson%20accent%20colors%2C%20minimalist%20UI%20design%2C%20editorial%20app%20aesthetic%2C%20no%20readable%20text%2C%20dark%20mode%20style&width=500&height=700&seq=app-mock-2026&orientation=portrait"
                  alt="黑料爆料移动端界面"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}